import PhoneIcon from "@/assets/templates/icons/dialIcon";
import { useTemplateContext } from "@/context/TemplateProvider";

import Layout from "./bakery-store.views";

const BakeryStoreTemplate = () => {
  const { template } = useTemplateContext();

  return (
    <Layout.Container
      className="select-none pointer-events-none"
      backgroundImage={template.sections.hero.backgroundImage}
    >
      <Layout.Header
        backgroundColor="secondary"
        textColor="secondary"
      >
        <Layout.HeaderContent>
        <Layout.Logo>
            {template.logo.src ? (
              <Layout.LogoImage src={template.logo.src} />
            ) : (
              <Layout.LogoText fontFamily={template.logo.fontFamily}>
                {template.logo.text}
              </Layout.LogoText>
            )}
          </Layout.Logo>
          <Layout.Menu>
            <Layout.PhoneButton>
              <PhoneIcon />
              555-555-5555
            </Layout.PhoneButton>
          </Layout.Menu>
        </Layout.HeaderContent>
      </Layout.Header>
      <Layout.Content>
        <Layout.InnerContent>
          <Layout.HeroTitle>{template.sections.hero.title}</Layout.HeroTitle>
        </Layout.InnerContent>
      </Layout.Content>
    </Layout.Container>
  );
};

export default BakeryStoreTemplate;
